import { useState, useEffect } from 'react';
import { Hourglass } from 'react-bootstrap-icons'; // Instala este paquete o usa un ícono similar.

export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00'
  });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_HOST_BACKEND}/deadline`, {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    })
      .then(res => res.json())
      .then(data => {
        const deadline = new Date(data.deadline).getTime();

        const timer = setInterval(() => {
          const now = new Date().getTime();
          const distance = deadline - now;

          if (distance < 0) {
            clearInterval(timer);
            setTimeLeft('OFERTA FINALIZADA');
          } else {
            const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0');
            const hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
            const minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
            const seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0');

            setTimeLeft({ days, hours, minutes, seconds });
          }
        }, 1000);

        return () => clearInterval(timer);
      });
  }, []);

  return (
    <div className="text-center my-5" style={{ backgroundColor: '#0B1F3A', color: '#fff', padding: '30px' }}>
      <h2 className="fw-bold mb-3" style={{color: 'white'}}>
        <Hourglass className="me-2" /> ¡Apúrate! ESTA OFERTA TERMINA EN:
      </h2>

      {typeof timeLeft === 'string' ? (
        <h2 className="text-warning">{timeLeft}</h2>
      ) : (
        <div style={{ display: 'inline-flex', gap: '20px', backgroundColor: '#FFCC00', color: '#000', borderRadius: '10px', padding: '15px 30px' }}>
       { <div className="text-center">
            <h1 className="fw-bold">{timeLeft.days}</h1>
            <small>Días</small>
          </div>}  
          <div className="text-center">
            <h1 className="fw-bold">{timeLeft.hours}</h1>
            <small>Horas</small>
          </div>
          <div className="text-center">
            <h1 className="fw-bold">{timeLeft.minutes}</h1>
            <small>Minutos</small>
          </div>
          <div className="text-center">
            <h1 className="fw-bold">{timeLeft.seconds}</h1>
            <small>Segundos</small>
          </div>
        </div>
      )}

      <h3 className="mt-4 text-warning">Cuando llegue a cero, el precio sube automáticamente🔥</h3>
    </div>
  );
};
